import { IContextualMenuItem, IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./SubMenuItem.scss');

/**
 * Utility which returns the contextual menu item based on the params and building suitable props
 * @param retentionId unique retention id of tag
 * @param displayName the text to be shown for menu item
 * @param isChecked denotes wheteher the policy tag is checked or not
 * @param subMenuProps props required to make submenu out of existing menu item
 * @param onClickCallback callback when a policy is selected
 */
export default function createSubMenuItem(config: {
    retentionId: string;
    displayName: string;
    isChecked: boolean;
    subMenuProps: IContextualMenuProps;
    onClickCallback: (
        ev: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item: IContextualMenuItem
    ) => void;
}): IContextualMenuItem {
    const { retentionId, displayName, isChecked, subMenuProps, onClickCallback } = config;
    const itemProps = isChecked ? { styles: { label: styles.checkedItem } } : null;
    const iconProps = isChecked
        ? {
              iconName: ControlIcons.CheckMark,
              className: styles.checkmark,
          }
        : null;
    return {
        key: retentionId,
        text: displayName,
        data: retentionId,
        onClick: onClickCallback,
        checked: isChecked,
        itemProps: itemProps,
        iconProps: iconProps,
        subMenuProps: subMenuProps,
    };
}
